/**
 * Icon — the stroked 24×24 glyphs used by the EGDL portal design.
 * Status glyphs use a 2.5 square stroke; navigation/action glyphs a 2 round stroke.
 */
export const ICONS = {
    profile: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4 21c0-4 4-6 8-6s8 2 8 6',
    players: 'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM2 21c0-3.5 3-5.5 7-5.5s7 2 7 5.5M16 3.5a4 4 0 0 1 0 7.5M18 15.5c2.4.6 4 2.4 4 5.5',
    live: 'M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM7.8 7.8a6 6 0 0 0 0 8.4M16.2 7.8a6 6 0 0 1 0 8.4M4.9 4.9a10 10 0 0 0 0 14.2M19.1 4.9a10 10 0 0 1 0 14.2',
    sessions: 'M8 6h13M8 12h13M8 18h13M3 6h1M3 12h1M3 18h1',
    addPlayer: 'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM2 21c0-3.5 3-5.5 7-5.5s7 2 7 5.5M19 8v6M16 11h6',
    logout: 'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9',
    menu: 'M3 6h18M3 12h18M3 18h18',
    close: 'M6 6l12 12M18 6L6 18',
    chevronLeft: 'M15 18l-6-6 6-6',
    chevronRight: 'M9 18l6-6-6-6',
    download: 'M12 3v12M7 10l5 5 5-5M4 21h16',
    search: 'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14zM21 21l-4.5-4.5',
    notFound: 'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14zM21 21l-4.5-4.5M8 11h6',
    warning: 'M12 7v6M12 16v1M12 3l10 18H2z',
    check: 'M5 12l5 5 9-11',
    clock: 'M12 6v6l4 3M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18z',
    cross: 'M6 6l12 12M18 6L6 18',
    dash: 'M7 12h10',
    mail: 'M3 5h18v14H3zM3 6l9 7 9-7',
    unlink: 'M9 15l6-6M7 11l-2 2a3.5 3.5 0 0 0 5 5l2-2M17 13l2-2a3.5 3.5 0 0 0-5-5l-2 2',
    eyeOff: 'M12 5c-6 0-9 7-9 7s3 7 9 7 9-7 9-7-3-7-9-7zM4 4l16 16',
    back5: 'M11 17l-5-5 5-5M18 17l-5-5 5-5',
    fwd5: 'M13 17l5-5-5-5M6 17l5-5-5-5',
    phone: 'M8 2h8a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zM11 18h2',
    webcam: 'M3 5h18v11H3zM8 20h8M12 16v4',
    kinect: 'M3 9h18v5H3zM7 11.5h.01M12 11.5h.01M17 11.5h.01M9 14l-1 4h8l-1-4',
    standing: 'M12 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM12 8v7M12 15l-3 6M12 15l3 6M8 11h8',
    sun: 'M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10zM12 1v2M12 21v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M1 12h2M21 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4',
    moon: 'M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z',
    arrowRight: 'M5 12h14M13 6l6 6-6 6',
    sortAsc: 'M12 19V5M6 11l6-6 6 6',
    sortDesc: 'M12 5v14M6 13l6 6 6-6',
    sortBoth: 'M8 9l4-4 4 4M8 15l4 4 4-4',
    refresh: 'M21 12a9 9 0 1 1-2.6-6.4M21 3v6h-6',
    gear: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z',
};

const FILLED = {
    play: 'M7 4l13 8-13 8z',
    pause: 'M6 4h4v16H6zM14 4h4v16h-4z',
};

const STATUS = new Set(['warning', 'check', 'clock', 'cross', 'dash', 'unlink', 'eyeOff']);

export default function Icon({ name, size = 22, strokeWidth, color = 'currentColor', className, style, title }) {
    const label = title ? { role: 'img', 'aria-label': title } : { 'aria-hidden': true };
    if (FILLED[name]) {
        return (
            <svg width={size} height={size} viewBox="0 0 24 24" fill={color} className={className} style={style} {...label}>
                <path d={FILLED[name]} />
            </svg>
        );
    }
    const status = STATUS.has(name);
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth ?? (status ? 2.5 : 2)}
            strokeLinecap={status ? 'square' : 'round'}
            strokeLinejoin={status ? 'miter' : 'round'}
            className={className}
            style={style}
            {...label}
        >
            <path d={ICONS[name] || ''} />
        </svg>
    );
}
